export class ComponentConvertHelper {
    static convertToCanvas(component, internalId, color, text, dimentionsRatio) {
        const convertedComponent = {
            id: component.id,
            internalId: internalId,
            type: component.type,
            color: color,
            text: text,
            geometries: component.geometries.map((geometry, idx) => this.convertGeometryToCanvas(geometry, idx, dimentionsRatio)),
            dataIdentifier: component.dataIdentifier,
            configuration: component.configuration,
            parameters: component.parameters,
            fonts: undefined === component.fonts ? [] : component.fonts.map(font => Object.assign({}, font)),
            backgrounds: undefined === component.backgrounds ? [] : component.backgrounds.map(background => Object.assign({}, background)),
            margins: undefined === component.margins ? [] : component.margins.map(margin => Object.assign({}, margin)),
            circleElements: undefined === component.circleElements ? [] : component.circleElements.map(circleElement => Object.assign({}, circleElement))
        };

        return convertedComponent;
    }

    static convertGeometryToCanvas(geometry, idx, dimentionsRatio) {
        return {
            id: idx,
            width: geometry.width,
            height: geometry.height,
            absolutePositionAxisX: geometry.positionAxisX,
            absolutePositionAxisY: geometry.positionAxisY,
            positionZ: geometry.positionAxisZ,
            drawPositionX: 5 + geometry.positionAxisX * dimentionsRatio,
            drawPositionY: 5 + geometry.positionAxisY * dimentionsRatio,
            offsetX: 0,
            offsetY: 0,
        };
    }
}
